import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core'
import { Artist } from 'src/app/models/artist.model'

@Component({
    selector: 'app-search-artist-result-item',
    changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="artist-result-row">

      @if (artist.arsha) {
        <img [src]="artist.arsha" class="arsha" />
      }

      @if (!artist.arsha) {
        <div class="arsha-empty">
          <div class="empty-label">
            {{ artist.nameMain }}
          </div>
        </div>
      }

      <div class="artist-info">
        <span class="name-main">
          {{ artist.nameMain }}
        </span>

        <span class="label">
          {{ artist.label }}
        </span>
      </div>

      <div class="artist-genre">
        <span class="genre">
          {{ artist.genre }}
        </span>
      </div>

    </div>
    `,
    styleUrls: ['./search-artist-result-item.component.scss'],
    standalone: false
})
export class SearchArtistResultItemComponent implements OnInit {
  @Input()
  artist: Artist

  constructor() {}

  ngOnInit() {}
}
